import React from 'react';
import { FormControl, FormLabel, InputGroup, Input, VStack, Stack, } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import { FormContainer } from '../Form/FormContainer';
const AddressManualInput = ({ addressFields, handleChange, useRow, }) => {
    const stackProps = {
        direction: useRow ? 'row' : 'column',
        alignItems: useRow ? 'center' : 'flex-start',
    };
    return (React.createElement(VStack, { w: "100%", "data-testid": "manual_address_entry_fields", position: "relative" },
        React.createElement(FormContainer, { w: "100%" },
            React.createElement(FormControl, null,
                React.createElement(Stack, { ...stackProps, spacing: 0 },
                    React.createElement(FormLabel, { w: "50%" }, localise('ADDRESS_LINE_1')),
                    React.createElement(InputGroup, null,
                        React.createElement(Input, { autoFocus: true, tabIndex: 0, value: addressFields?.address_1, "aria-required": "true", name: "manual_address.address_1", onChange: handleChange, type: "text", w: "100%", variant: "filled" })))),
            React.createElement(FormControl, null,
                React.createElement(Stack, { ...stackProps, spacing: 0 },
                    React.createElement(FormLabel, { w: "50%" }, localise('ADDRESS_LINE_2')),
                    React.createElement(InputGroup, null,
                        React.createElement(Input, { tabIndex: 0, value: addressFields?.address_2, "aria-required": "false", name: "manual_address.address_2", onChange: handleChange, type: "text", w: "100%", variant: "filled" })))),
            React.createElement(FormControl, null,
                React.createElement(Stack, { ...stackProps, spacing: 0 },
                    React.createElement(FormLabel, { w: "50%" }, localise('CITY_TOWN')),
                    React.createElement(InputGroup, null,
                        React.createElement(Input, { tabIndex: 0, value: addressFields?.city, "aria-required": "true", name: "manual_address.city", onChange: handleChange, type: "text", w: "100%", variant: "filled" })))),
            React.createElement(FormControl, null,
                React.createElement(Stack, { ...stackProps, spacing: 0 },
                    React.createElement(FormLabel, { w: "50%" }, localise('COUNTY')),
                    React.createElement(InputGroup, null,
                        React.createElement(Input, { tabIndex: 0, value: addressFields?.county, "aria-required": "false", name: "manual_address.county", onChange: handleChange, type: "text", w: "100%", variant: "filled" })))),
            React.createElement(FormControl, null,
                React.createElement(Stack, { ...stackProps, spacing: 0 },
                    React.createElement(FormLabel, { w: "50%" }, localise('POSTCODE')),
                    React.createElement(InputGroup, null,
                        React.createElement(Input, { tabIndex: 0, value: addressFields?.postcode, "aria-required": "true", name: "manual_address.postcode", onChange: handleChange, type: "text", w: "100%", variant: "filled" })))))));
};
export default AddressManualInput;
